var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHospedaje(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #1d1d1b;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.75,346.99H148.25c-19.38,0-35.16-15.77-35.16-35.16V64.17c0-19.39,15.78-35.16,35.16-35.16h215.51c19.38,0,35.16,15.77,35.16,35.16v247.67c0,19.39-15.78,35.16-35.16,35.16ZM148.25,43.47c-11.41,0-20.69,9.29-20.69,20.7v247.67c0,11.41,9.28,20.7,20.69,20.7h215.51c11.41,0,20.69-9.29,20.69-20.7V64.17c0-11.41-9.28-20.7-20.69-20.7H148.25Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.89,
    y: 90.72,
    width: 14.47,
    height: 199.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 315.36,
    y: 90.72,
    width: 14.47,
    height: 199.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 196.47,
    y: 183.47,
    width: 126.4,
    height: 14.46
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospedaje);
export default __webpack_public_path__ + "static/media/hospedaje.5655c5fc6592c6d54ab13f6045c6403f.svg";
export { ForwardRef as ReactComponent };